import dayjs from 'dayjs';

export const dataFilter = function(val, str = 'YYYY-MM-DD') {
    if (val) {
        return dayjs(val).format(str);
    } else {
        return '';
    }
};

export const point = function(val, num = 2) {
    if (!val) {
        return 0;
    }
    return Number(val).toFixed(num);
};

export const splitRoomSn = function(val) {
    if (!val) {
        return;
    }
    return val.split(':')[1]
};

export const isPermission = function(val) {
    let isHave = JSON.parse(localStorage.getItem('current_user')).permissions.indexOf(val)
    return isHave == '-1' ?false:true

};

export const isRole = function(val) {
  let allRoles;
  let isAdmin;
  if (localStorage.getItem('current_user') == "undefined" || localStorage.getItem('current_user') == "null") {
    return false
  }
  isAdmin = JSON.parse(localStorage.getItem('current_user'))
  if (localStorage.getItem('roles') == "null" || localStorage.getItem('roles') == "undefined") {
    return  false
  }
  allRoles = JSON.parse(localStorage.getItem('roles'))

    if(isAdmin.id == '1'){
        return true;
    }else{
        for (let i = 0; i < allRoles.length; i++){
            if(allRoles[i].name == val){
                return true;
            }
        }
        return false;
    }
};

export const nameFilter = function(val, status, cancelTime, endTime) {
    if(status == '3' && cancelTime){
        let days = dayjs().diff(dayjs(cancelTime),'day')
        if(days > 7){
            return val.replace(/.(?=.)/g, '*')
        }else{
            return val
        }
    }else if(status == '7' && endTime){
        let days = dayjs().diff(dayjs(endTime),'day')
        if(days > 7){
            return val.replace(/.(?=.)/g, '*')
        }else{
            return val
        }
    }else{
        return val
    }
};

export const phoneFilter = function(val, status, cancelTime, endTime) {
    if(status == '3' && cancelTime){
        let days = dayjs().diff(dayjs(cancelTime),'day')
        if(days > 7){
            return val.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
        }else{
            return val
        }
    }else if(status == '7' && endTime){
        let days = dayjs().diff(dayjs(endTime),'day')
        if(days > 7){
            return val.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
        }else{
            return val
        }
    }else{
        return val
    }
};

export const idsFilter = function(val, status, cancelTime, endTime) {
    if(status == '3' && cancelTime){
        let days = dayjs().diff(dayjs(cancelTime),'day')
        if(days > 7){
            return val.replace(/^(.{6})(?:\d+)(.{4})$/, "$1********$2")
        }else{
            return val
        }
    }else if(status == '7' && endTime){
        let days = dayjs().diff(dayjs(endTime),'day')
        if(days > 7){
            return val.replace(/^(.{6})(?:\d+)(.{4})$/, "$1********$2")
        }else{
            return val
        }
    }else{
        return val
    }
};



// WEBPACK FOOTER //
// ./src/utils/filters.js